import Vue from 'vue';
import Router from 'vue-router';
/* AUTH */
import Index from './pages/auth/index/Index.vue';
import Login from './pages/auth/login/Login.vue';
import LoginExternal from './pages/auth/loginExternal/LoginExternal.vue';
import Register from './pages/auth/register/Register.vue';
import RemindPassword from './pages/auth/remindPassword/RemindPassword.vue';
/* PRIZES */
import Orders from './pages/prizes/orders/Orders.vue';
import Prizes from './pages/prizes/prizes/Prizes.vue';
import EpsCard from './pages/prizes/epsCard/EpsCard.vue';
/* PROFILE */
import Dashboard from './pages/profile/dashboard/Dashboard.vue';
import ProfilePassport from './pages/profile/profilePassport/ProfilePassport.vue';
import ProfileEdit from './pages/profile/profileEdit/ProfileEdit.vue';
import ProfilePurse from './pages/profile/profilePurse/ProfilePurse.vue';
import ProfileBonuses from './pages/profile/profileBonuses/ProfileBonuses.vue';
/* COURSES */
import Courses from './pages/courses/courses/Courses.vue';
import Course from './pages/courses/course/Course.vue';
import Test from './pages/courses/test/Test.vue';
import Results from './pages/courses/result/Results.vue';
/* SALES */
import Sales from './pages/sales/sales/Sales.vue';
import AddSale from './pages/sales/addSale/AddSale.vue';
import Sale from './pages/sales/sale/Sale.vue';
/* NEWS & INSTRUCTIONS */
import News from './pages/news/news/News.vue';
import Publication from './pages/news/publication/Publication.vue';
import Instructions from './pages/news/instructions/Instructions.vue';
import Instruction from './pages/news/instruction/Instruction.vue';
/* TICKETS */
import Tickets from './pages/tickets/tickets/Tickets.vue';
/* NOTIFICATIONS */
import MobileNotifications from './pages/mobileNotifications/MobileNotifications.vue';
/* COMMON */
import Feedback from './pages/feedback/Feedback.vue';
import NotFound from './pages/NotFound.vue';
import Reset from './pages/Reset.vue';
/* SHOP */
import Shop from './pages/shop/products/Products.vue';
import ShopProduct from './pages/shop/product/Product.vue';
/* CART */
import Cart from './pages/cart/Cart.vue';
/* RULES */
import Rules from './pages/rules/Rules.vue';
/* WINNERS */
import Winners from './pages/winners/Winners.vue';
/* SURVEYS */
import SurveysList from './pages/surveys/surveys-list/SurveysList.vue';
import SurveysDetails from './pages/surveys/surveys-details/SurveysDetails.vue';
/* CHAT */
import Chat from './pages/chat/Chat.vue';
/* Actions */
import Actions from './pages/sales/actions/Actions.vue';
import ProfileStatus from './pages/profile/profileStatus/ProfileStatus.vue';
/* GAME */
import GameList from './pages/game/list/GameList.vue';


Vue.use(Router);

const routes = [
  { name: '', path: '/', component: Index, meta: { requiresGuest: true } },
  { name: 'login', path: '/login/:type', props: true, component: Login, meta: { requiresGuest: true } },
  { name: 'login-external', path: '/login-external/:id/:token', component: LoginExternal, props: true, meta: { requiresGuest: true } },
  { name: 'register', path: '/register/:type', component: Register, props: true, meta: { requiresGuest: true } },
  { name: 'remind', path: '/remind/:type', props: true, component: RemindPassword, meta: { requiresGuest: true } },
  { name: 'orders', path: '/orders', component: Orders, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'prizes', path: '/prizes', component: Prizes, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true, requiresBonuses: true } },
  { name: 'eps', path: '/eps/:type', component: EpsCard, props: true, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'dashboard', path: '/dashboard', component: Dashboard, meta: { requiresAuth: true, requiresSurveys: true } },
  { name: 'passport', path: '/passport', component: ProfilePassport, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true, requiresNdfl: true } },
  { name: 'profile', path: '/profile', component: ProfileEdit, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'purse', path: '/purse', component: ProfilePurse, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'bonuses', path: '/bonuses/:period', component: ProfileBonuses, props: true, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'courses', path: '/courses', component: Courses, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'course', path: '/course/:id', component: Course, props: true, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'test', path: '/test/:id', component: Test, props: true, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'results', path: '/results/:id', component: Results, props: true, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'news', path: '/news', component: News, meta: { requiresAuth: true, requiresSurveys: true, rules: true } },
  { name: 'publication', path: '/publication/:id', component: Publication, props: true, meta: { requiresAuth: true, requiresSurveys: true, rules: true } },
  { name: 'instructions', path: '/instructions', component: Instructions, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'instruction', path: '/instruction/:id', component: Instruction, props: true, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'cart', path: '/cart', component: Cart, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'shop', path: '/shop', component: Shop, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'shop-product', path: '/shop-product/:id', component: ShopProduct, props: true, meta: { requiresAuth: true, rules: true, approved: true, requiresSurveys: true } },
  { name: 'notifications', path: '/notifications', component: MobileNotifications, meta: { requiresAuth: true, requiresSurveys: true, rules: true } },
  { name: 'tickets', path: '/tickets/', component: Tickets, meta: { requiresAuth: true, requiresSurveys: true, rules: true } },
  { name: 'sales', path: '/sales', component: Sales, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { path: '/sale/:action_id', component: AddSale, props: true, meta: { requiresAuth: true } },
  { path: '/actions', component: Actions, meta: { requiresAuth: true, requiresChecked: true, requiresActions: true } },
  { name: 'sale-form', path: '/sale-form/:action_id/:sale_id', component: AddSale, props: true, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'sale', path: '/sales/:id', component: Sale, props: true, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'reset', path: '/reset', component: Reset },
  { name: 'feedback', path: '/feedback', component: Feedback, meta: { rules: true } },
  { name: 'rules', path: '/rules', component: Rules, meta: { requiresAuth: true, requiresSurveys: true } },
  { name: 'winners', path: '/winners', component: Winners, meta: { requiresAuth: true, approved: true, requiresSurveys: true, rules: true } },
  { name: 'surveys', path: '/surveys', component: SurveysList, meta: { requiresAuth: true, rules: true } },
  { name: 'survey', path: '/survey/:id', component: SurveysDetails, props: true, meta: { requiresAuth: true, rules: true } },
  { path: '/chat/:id', component: Chat, props: true, meta: { requiresAuth: true, requiresChecked: true } },
  { name: 'status', path: '/status', component: ProfileStatus, meta: { requiresAuth: true, requiresChecked: true } },
  { path: '/games', name: 'games', component: GameList, meta: { requiresAuth: true, requiresGame: true } },
  { name: '', path: '*', component: NotFound },
];

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  // Vue.notify({ group: 'error', clean: true });
  const { requiresGuest, requiresAuth, approved, requiresSurveys, requiresNdfl, requiresActions,
    requiresBonuses, rules, requiresGame } = to.meta;
  let isRulesConfirm = false;
  let isAuthenticated = false;
  let isConfirmed = false;
  let hasSurveys = false;
  let chowNdfl = false;
  let showActions = false;
  let showPrizes = false;
  let showGames = false;
  const storage = localStorage.getItem('promo');

  if (storage !== null) {
    const { token, user, surveys, game } = JSON.parse(storage);

    if (token !== undefined && token !== null) {
      isAuthenticated = true;
    }
    if (isAuthenticated && user && user.confirmed) {
      isConfirmed = true;
    }
    if (isAuthenticated && user && !user.show_rules) {
      isRulesConfirm = true;
    }
    if (isAuthenticated && user && user.role_settings && user.role_settings.modules_ndfl) {
      chowNdfl = true;
    }
    if (isAuthenticated && user && user.role_settings && user.role_settings.modules_tasks
      && game.gamesList.length) {
      showGames = true;
    }
    if (isAuthenticated && user && user.role_settings && user.role_settings.modules_actions) {
      showActions = true;
    }
    if (isAuthenticated && user && user.role_settings
      && user.role_settings.property_can_spend_bonuses) {
      showPrizes = true;
    }
    if (surveys.surveys && surveys.surveys.length) {
      hasSurveys = true;
    }
  }

  if (requiresGuest && isAuthenticated) {
    next('/dashboard');
  } else {
    next();
  }

  if (isAuthenticated && ((approved && !isConfirmed) || (rules && !isRulesConfirm))) {
    if (!isRulesConfirm) {
      Vue.notify({ group: 'error', clean: true });
      Vue.notify({
        group: 'error',
        type: 'error',
        text: 'Чтобы перейти в другие разделы Вы должны принять правила мотивационной программы!',
        duration: 10000,
      });
    }
    next('/dashboard');
  } else {
    next();
  }

  if (isAuthenticated && requiresNdfl && !chowNdfl) {
    next('/dashboard');
  } else {
    next();
  }

  if (isAuthenticated && requiresGame && !showGames) {
    next('/dashboard');
  } else {
    next();
  }

  if (isAuthenticated && requiresActions && !showActions) {
    next('/dashboard');
  } else {
    next();
  }

  if (isAuthenticated && requiresBonuses && !showPrizes) {
    next('/dashboard');
  } else {
    next();
  }

  if (isAuthenticated && requiresSurveys && hasSurveys) {
    next('/surveys');
  } else {
    next();
  }

  if (requiresAuth && !isAuthenticated) {
    next('/login');
  } else {
    next();
  }
});

export default router;
